// Copyright (c) StrangeBee 2023

import { useGenericQuery } from '@Queries/genericQueries';
import { ReactElement } from 'react';
import { QueryKey, UseQueryResult } from 'react-query';
import { ParentController, QueryParams, QuerySelector } from 'thehive-sdk';

interface UseOneQueryParams extends QueryParams {
    controller: ParentController;
    manual?: boolean;
    fetchOnStart?: boolean;
    activePagination?: boolean;
    selector: QuerySelector;
}

interface ExtractDataQueryProps {
    selector: any;
    controller: any;
    children: any;
}

const useOneQuery = <T,>(params: UseOneQueryParams): UseQueryResult<T, QueryKey> => {
    const { selector, controller, manual, fetchOnStart, activePagination = true, ...opt } = params;
    let paginationParams = {};

    if (activePagination) {
        paginationParams = { paginationOptions: { page: 0, itemsPerPage: 1 } };
    }

    return useGenericQuery<T>({
        fetchCallback: () => controller.one<T>({ selector, ...paginationParams, ...opt }),
        key: [selector.name],
        fetchOnStart,
        manual,
    });
};

export const ExtractDataQuery = ({ selector, controller, children }: ExtractDataQueryProps): ReactElement | null => {
    const { data: dataSource } = useOneQuery({ selector, controller });
    return dataSource ? children(dataSource) : null;
};

export default useOneQuery;
